import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { ConfirmEnrollmentInput } from '../../../lib/types/models/enrollment/enrollment-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import ControlledSwitch from '../../elements/controlled-switch'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<ConfirmEnrollmentInput> & {
  className?: string
}

const formSchema: ZodType<ConfirmEnrollmentInput> = z.object({
  isAA: z.boolean().optional()
})

export const CheckAaForm = ({ defaultValues, className, ...validationButtonProps }: Props) => {
  const form = useForm<ConfirmEnrollmentInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <div className="flex justify-center items-center">
            <FormField
              control={form.control}
              name={'isAA'}
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledSwitch
                      {...field}
                      label={'Taguer AA'}
                      variant={'tag'}
                      withBorder
                      borderClassName={'border-grey-light px-3 py-2 rounded'}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}
